const readNumberEnv = (envValue: string | undefined): number | null => {
  let parsedNumber: number | null = null;
  if (envValue !== undefined && envValue.length !== 0) {
    parsedNumber = Number(envValue);
    if (isNaN(parsedNumber)) {
      parsedNumber = null;
    }
  }

  return parsedNumber;
};

export default readNumberEnv;
